import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { getLPSettings } from "../../services/api";
import { useTheme } from "../../contexts/ThemeContext";
import "./Footer.css";

const Footer = () => {
  const { logoUrl, loading } = useTheme();
  const [lpSettings, setLpSettings] = useState(null);

  useEffect(() => {
    getLPSettings()
      .then((res) => setLpSettings(res.data))
      .catch(() => {});
  }, []);

  const namaLembaga = lpSettings?.nama_lembaga || "";
  const alamat =
    lpSettings?.alamat ||
    "Jl.Danau Singkarak No.32 LK.I, Kelurahan Surabaya Kecamatan Kedaton, Bandar Lampung Lampung 35148";
  const noHp = lpSettings?.no_hp || "+6282182226942";
  const email = lpSettings?.email || "edukasihalalindonesia@gmail.com";

  return (
    <footer className="footer bg-dark text-white mt-5">
      <Container>
        <Row className="py-5">
          <Col md={4} className="mb-4">
            <div className="d-flex align-items-center mb-3">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt={namaLembaga || "Logo Lembaga"}
                  style={{ width: "50px", height: "50px", marginRight: "15px" }}
                />
              ) : loading ? (
                <span
                  className="footer-logo-placeholder"
                  style={{ marginRight: "15px" }}
                  aria-hidden="true"
                />
              ) : null}
              <h5 className="mb-0">{namaLembaga}</h5>
            </div>
            <p className="text-light">
              Lembaga halal yang berkomitmen untuk menjaga kehalalan produk di
              Indonesia.
            </p>
          </Col>

          <Col md={4} className="mb-4">
            <h5 className="mb-3">Kontak</h5>
            <div className="contact-info">
              <p>
                <FaMapMarkerAlt /> {alamat}
              </p>
              <p>
                <FaPhone /> {noHp}
              </p>
              <p>
                <FaEnvelope /> {email}
              </p>
            </div>
          </Col>

          <Col md={4} className="mb-4">
            <h5 className="mb-3">Ikuti Kami</h5>
            <div className="social-icons">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook size={30} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter size={30} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram size={30} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube size={30} />
              </a>
            </div>
          </Col>
        </Row>

        <Row>
          <Col className="text-center py-3 border-top border-secondary">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} {namaLembaga}. All rights
              reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
